import PropTypes from 'prop-types';
import { minutesFormat } from 'shared/utils';
import moment from 'moment';
import React, { Component } from 'react';

class Timer extends Component {
    constructor (props) {
        super(props);
        this.state = {
            seconds: 0
        };
        this.interval = setInterval(this.getNewSeconds, 1000);
    }

    componentWillUnmount = () => {
        clearInterval(this.interval);
    };
    
    getNewSeconds = () => {
        const { from, max, onMax } = this.props;
        if (!!from) {
            const seconds = moment().diff(moment(from), 'seconds');
            if (!!onMax && !!max && seconds === max) {
                onMax();
            }
            this.setState({
                seconds
            });
        }
    };

    render () {
        const { max } = this.props;
        const { seconds } = this.state;
        if (!max || seconds <= max) {
            return (` hace ${ minutesFormat(seconds) }`);
        } else {
            return '';
        }
    }
}

Timer.propTypes = {
    from: PropTypes.any,
    max: PropTypes.number,
    onMax: PropTypes.func
};

export default Timer;
